import { Timeline } from "primereact/timeline";
import * as React from "react";
import "./PrwcTimeline.scss";

const PrwcTimeline = (props: any) => {
  const { events, marker, content, align = "left" } = props;

  return (
    <div className="prwc-timeline">
      <Timeline value={events} marker={marker} content={content} align={align}/>
    </div>
  );
};

export default PrwcTimeline;
